/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoLight } from "~/foundation/Components/Logo";

export const getAramcoBlueColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Aramco Blue",
	colors: {
		ribbon: {
			bg: "themeBackgroundColors.aramcoBlue",
			color: "primary.white",
			border: "primary.neutralGrey",
			linkColor: "primary.white"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue",
		},
		header: {
			bg: "themeBackgroundColors.aramcoBlue",
			bgInactive: "themeBackgroundColors.aramcoBlue",
			color: "primary.white",
			activeColor: "primary.text",
			hygieneColor: "primary.white",
			hygieneGlobalContacts: "primary.white",
			burgerMenuColor: "primary.white"
		},
		siteNavigation: {
			gradient: "siteNavigation.darkTheme.gradient",
			bg: "siteNavigation.darkTheme.bg",
			color: "siteNavigation.darkTheme.color",
		},
		footer: {
			bg: "themeBackgroundColors.aramcoBlue",
			color: "primary.white"
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.darkTheme.linkColor",
			activeColor: "aramcoBreadcrumb.darkTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.darkTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.darkTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.darkTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.white",
			color: "primary.text",
			linkColor: "primary.aramcoLinkBlue"
		},
		tags: {
			color: "primary.aramcoGrey"
		},
		switch: {
			color: "primary.white",
		}
	},
	Logo: () => <LogoLight height={25} />,
	FooterLogo: () => <LogoLight height={29} />
});